export default __webpack_public_path__ + "static/J-Hooks-e4791ad798175b502a956e8cb89bacc7.png";